import { GuiTimeZone } from "@mm/metx-workbench.meteomatics.com";

/**
 * Labels appended to the time shown in the header of a Highcharts tooltip.
 * Same wording as the timezone switch in the time settings (`TimeZoneInput`).
 */
const TIMEZONE_LABEL: Record<GuiTimeZone, string> = {
  [GuiTimeZone.utc]: "UTC",
  [GuiTimeZone.local]: "Local",
};

/**
 * Highcharts' default `tooltip.dateTimeLabelFormats` for the units that show a time of day,
 * with the timezone label appended. Coarser units (day, week, month, year) show no time of day
 * and therefore keep the Highcharts default.
 */
export function getTooltipDateTimeLabelFormats(timezone: GuiTimeZone): Record<string, string> {
  const label = TIMEZONE_LABEL[timezone];
  return {
    millisecond: `%[AebHMSL] ${label}`,
    second: `%[AebHMS] ${label}`,
    minute: `%[AebHM] ${label}`,
    hour: `%[AebHM] ${label}`,
  };
}
